import { useSyncExternalStore } from "react";

// Globalny stan otwarcia drawera agenta. Drawer jest zamontowany w Dashboard
// (trwały layout), żeby rozmowa przeżywała nawigację między stronami — strony
// (np. ProgramsList) sterują nim przez ten store zamiast lokalnego useState.
let isOpen = false;
const listeners = new Set<() => void>();

const emit = () => {
  for (const listener of listeners) listener();
};

export const openTrainingProgramAgentDrawer = () => {
  isOpen = true;
  emit();
};

export const closeTrainingProgramAgentDrawer = () => {
  isOpen = false;
  emit();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => isOpen;

export const useTrainingProgramAgentDrawerOpen = () => useSyncExternalStore(subscribe, getSnapshot);
